import { render, staticRenderFns } from "./CostosPorUbicacionMantenimiento.vue?vue&type=template&id=2ceb84fa&"
import script from "./CostosPorUbicacionMantenimiento.vue?vue&type=script&lang=js&"
export * from "./CostosPorUbicacionMantenimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports